// Module
var code = `jobSummariesComponent`;
// Exports
export default code;